import React, { useEffect, useState } from "react";
import { Row, Col } from "../../ui/Grid";
import Skeleton from "../../ui/Skeleton";

import productsPicture from "../../FormLocalSearch/assets/audit/Produits-renseignés.png";
import postsPicture from "../../FormLocalSearch/assets/audit/google-posts.jpg";
import FAQ from "../../FormLocalSearch/assets/audit/FAQ.png";
import ProgressCircle from "../ProgressCircle";
import useLang from "../../../i18n/useLang";
import content from "./content";

const Engagement = ({ auditInfo }) => {
  const all = content[useLang()];
  const t = all.engagement;
  const [score, setScore] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getScore = async () => {
      let score = 0;
      if (auditInfo.HasProducts) {
        score = score + 34;
      }
      if (auditInfo.HasPosts) {
        score = score + 33;
      }
      if (auditInfo.IsQandAFilled) {
        score = score + 33;
      }
      setScore(score);
      setLoading(false);
    };
    getScore();
  }, [auditInfo.HasProducts, auditInfo.HasPosts, auditInfo.IsQandAFilled]);

  if (loading) {
    return (
      <div className="featureblock-container">
        <div className="card-header">
          <span>{all.essentials.title}</span>
        </div>
        <div className="card-graph-body">
          <div className="sumup-category">
            <Skeleton />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="featureblock-container">
        <div className="card-header">
          <span>{t.title}</span>
        </div>
        <div className="card-graph-body">
          <div className="sumup-category">
            <Row>
              <Col xl={10} lg={10} sm={24} className="progress-category">
                <ProgressCircle type="circle" score={score} />
              </Col>
              <Col xl={14} lg={14} sm={24}>
                <div style={{ marginTop: "20px" }}>
                  {t.intro}
                </div>
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.HasProducts ? (
                      <>
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.products}{" "}
                      </>
                    ) : (
                      <>
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noProducts}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  <span>{t.productsDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                <img src={productsPicture} width="80%" alt={t.productsAlt} />
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.HasPosts ? (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.posts}{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noPosts}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  <span>{t.postsDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                {" "}
                <img src={postsPicture} width="90%" alt={t.postsAlt} />
              </Col>
            </Row>
          </div>
          <div className="criteria-audit">
            <Row gutter={30}>
              <Col xl={14} lg={14} sm={24}>
                <div className="criteria-status">
                  <span>
                    {auditInfo.IsQandAFilled ? (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ✅
                        </span>
                        {t.qa}{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span
                          role="img"
                          className="issue-icon"
                          aria-label="emoji"
                        >
                          ❌
                        </span>
                        {t.noQa}
                      </>
                    )}
                  </span>
                </div>
                <div className="criteria-description">
                  <span>{t.qaDesc}</span>
                </div>
              </Col>
              <Col xl={10} lg={10} sm={24}>
                <img
                  src={FAQ}
                  width="90%"
                  style={{ marginTop: 80 }}
                  alt={t.qaAlt}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
};

export default Engagement;
